import { useViewportSize } from "@mantine/hooks";
import { useMemo } from "react";

export enum EBreakpoints {
  BASE = 320,
  XS = 576,
  SM = 768,
  MD = 992,
  LG = 1200,
  XL = 1408,
}

export type TBreakpointName = "base" | "xs" | "sm" | "md" | "lg" | "xl";

const breakpointsName: Record<EBreakpoints, TBreakpointName> = {
  [EBreakpoints.BASE]: "base",
  [EBreakpoints.XS]: "xs",
  [EBreakpoints.SM]: "sm",
  [EBreakpoints.MD]: "md",
  [EBreakpoints.LG]: "lg",
  [EBreakpoints.XL]: "xl",
};

export const useBreakpoint = () => {
  const { width } = useViewportSize();

  const breakpoint: EBreakpoints = useMemo(() => {
    if (width >= EBreakpoints.XL) {
      return EBreakpoints.XL;
    }

    if (width >= EBreakpoints.LG) {
      return EBreakpoints.LG;
    }

    if (width >= EBreakpoints.MD) {
      return EBreakpoints.MD;
    }

    if (width >= EBreakpoints.SM) {
      return EBreakpoints.SM;
    }

    if (width >= EBreakpoints.XS) {
      return EBreakpoints.XS;
    }

    return EBreakpoints.BASE;
  }, [width]);

  return {
    breakpoint,
    breakpointName: breakpointsName[breakpoint],
  };
};
